import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { DTO__user_settings } from '@shared/dto/+user/user_settings/DTO__user_settings';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';
import { StateUser } from '../state_user';

export const REMOTE__user_settings_update = createAsyncThunkSafe<void, DTO__user_settings>(
  ENUM__network_event_client_to_server.USER_SETTINGS_UPDATE,
  async (settings): Promise<void> => {
    // todo: remove after fixing bug with stub
    if (settings.is_stub()) debugger;

    return await send_to_server(ENUM__network_event_client_to_server.USER_SETTINGS_UPDATE, settings);
  },
);

export function init_remote_settings_user_update(builder: ActionReducerMapBuilder<StateUser>) {
  builder
    .addCase(REMOTE__user_settings_update.pending, (state, action) => {
      state.user_settings = action.meta.arg;
    })
    .addCase(REMOTE__user_settings_update.rejected, (state, action) => {})
    .addCase(REMOTE__user_settings_update.fulfilled, (state, action: PayloadAction) => {});
}
